<template>
    <el-container>
        <el-main :style="viewType === 'month' || viewType === '' ? 'padding-bottom:110px' : ''">
            <div class="calendar-container">
                <div id="calendar" class="person-calendar" />
                <div v-if="customview">
                    <custom-view-calender :type="viewType" :view-data="viewData" :start-date="start" @click="viewObj" />
                </div>
            </div>
        </el-main>
    </el-container>
</template>

<script>
import $ from 'jquery'
if (!window.jQuery) {
    window.jQuery = $
}
// const moment = require('moment')
// import 'fullcalendar-scheduler/dist/scheduler.min.css'
// import 'fullcalendar'
// import 'fullcalendar-scheduler'
import customViewCalender from './customViewCalender'
import qs from 'qs'

export default {
    components: {
        customViewCalender
    },
    props: {
        moduleInfo: {
            type: Object,
            default() {
                return {}
            }
        }
    },
    data() {
        return {
            loginUser: this.$store.getters.loginUser,
            calendar: null,
            options: {
                locale: 'zh-cn',
                customButtons: {
                    customExportBtn: {
                        text: this.$tx('pageBtns.export', '导出'),
                        icon: '',
                        click: this.exportCalender
                    }
                },
                header: {
                    left: 'prev,next,today',
                    center: 'title',
                    right: 'month,agendaWeek,agendaDay,listWeek,customExportBtn'
                },
                buttonText: {
                    // 头部按钮的显示文本信息
                    today: '今天',
                    month: '月',
                    agendaWeek: '周',
                    agendaDay: '日',
                    listWeek: '日程'
                },
                eventColor: 'var(--bgColor)',
                eventTextColor: '#fff',
                allDayText: '全天', // 日历上方显示全天信息的文本
                firstDay: 0,
                timeFormat: 'HH:mm',
                navLinks: true,
                editable: false,
                eventLimit: true,
                lazyFetching: false,
                droppable: true,
                slotLabelFormat: 'HH',
                slotEventOverlap: false,
                fixedWeekCount: false, // 是否固定日历高度
                schedulerLicenseKey: 'CC-Attribution-NonCommercial-NoDerivatives',
                events: [], // 个人日程
                dayClick: (event, jsEvent, view) => {
                    const edata = event.format('YYYY-MM-DD') + ' 00:00:00'
                    this.addNew(edata)
                },
                eventClick: (event) => {
                    this.view(event, event.startDate)
                },
                eventMouseover: (event, ev, view) => {
                    var delbtn_html = '<a class = "event_del btn btn-xs"><i class="el-icon-close"></i></a>'
                    var $txargetEle = $(ev.currentTarget).children('.fc-content')
                    $txargetEle.append(delbtn_html)
                    $('.event_del').click((e) => {
                        e.stopPropagation()
                        this.deleteIds(event, event.startDate)
                    })
                    $('.fc-scroller')[0].style.overflow = 'visible'
                    // 事件提示
                    if (view.name !== 'listWeek') {
                        if (event.ownerUserId === this.loginUser.userId) {
                            $(ev.currentTarget).append(this.tipTemEdit)
                        } else {
                            $(ev.currentTarget).append(this.tipTemRead)
                        }
                        $('#event-detail').css('opacity', 100)
                        const eventTitle = event.title
                        const eventStart = event.start.format('YYYY-MM-DD HH:mm')
                        const eventEnd = event.end.format('YYYY-MM-DD HH:mm')
                        $('.tip-title').text(eventTitle)
                        $('.tip-start').text(this.$tx('ecoa.calendar.startTimeColon', '开始时间：') + eventStart)
                        $('.tip-end').text(this.$tx('ecoa.calendar.endTimeColon', '结束时间：') + eventEnd)
                        $('#event-detail').click((e) => {
                            e.stopPropagation()
                        })
                        $('.addbtn').click((e) => {
                            e.stopPropagation()
                            this.addNew()
                        })
                        $('.viewbtn').click((e) => {
                            e.stopPropagation()
                            this.view(event, event.startDate)
                        })
                        $('.delbtn').click((e) => {
                            e.stopPropagation()
                            this.deleteIds(event, event.startDate)
                        })
                    }
                },
                eventMouseout: (event, ev) => {
                    $('.event_del').remove()
                    $('#event-detail').css('opacity', 0).remove()
                }
            },
            vo: {},
            tipTemEdit: `
            <div id="event-detail">
                <div class="detail-list">
                    <div class="tip-title" />
                    <div class="tip-start" />
                    <div class="tip-end" />
                </div>
                <div class="action-group">
                    <button type="primary" class="el-button el-button--primary el-button--mini viewbtn" size="mini" style="float:right;margin-left:10px" v-pageBtn-lbl="'lookDetails'">查看详情</button>
                    <button plain size="mini" class="el-button el-button--default el-button--mini is-plain delbtn" style="float:right;" v-pageBtn-lbl="'del'">删除</button>
                </div>
                <div class="arrow" />
            </div>
            `,
            tipTemRead: `
            <div id="event-detail">
                <div class="detail-list">
                    <div class="tip-title" />
                    <div class="tip-start" />
                    <div class="tip-end" />
                </div>
                <div class="action-group">
                    <button type="primary" class="el-button el-button--primary el-button--mini viewbtn" size="mini" style="float:right;margin-left:10px" v-pageBtn-lbl="'lookDetails'">查看详情</button>
                </div>
                <div class="arrow" />
            </div>
            `,
            start: '', // 日历开始时间
            end: '', // 日历结束时间
            customview: false,
            viewType: '',
            viewData: []
        }
    },
    computed: {},
    watch: {},
    created() {
        this.$bus.emit('showNavSearch', false) // 取消右上搜索按钮
    },
    beforeDestroy() {
        this.$bus.emit('showNavSearch', true) // 还原右上搜索按钮
        $(document).off('click', '.fc-toolbar .fc-button') // 卸载按钮绑定事件
        this.calendar = null
    },
    mounted() {
        this.$nextTick(() => {
            this.renderCalendar()
        })
        $(document).on('click', '.fc-toolbar .fc-button-group', async () => {
            const view = this.getviews()
            const calenderView = document.querySelector('.person-calendar .fc-view-container')
            if (view.type !== 'month') {
                calenderView.style.display = 'none'
                this.customview = true
            } else {
                this.viewType = 'month'
                this.customview = false
                calenderView.style.display = ''
            }
            await this.queryData()

            if (view.type === 'agendaWeek') {
                this.viewType = 'week'
            } else if (view.type === 'agendaDay') {
                this.viewType = 'day'
            } else if (view.type === 'listWeek') {
                this.viewType = 'listWeek'
            }
        })
    },
    methods: {
        renderCalendar() {
            // 渲染日历
            if (this.calendar) {
                $('#calendar').fullCalendar('destroy')
            }
            this.calendar = $('#calendar').fullCalendar(this.options)
            this.queryData()
        },
        renderEvent(events) {
            // 重新渲染事件
            $('#calendar').fullCalendar('removeEvents') // 删除原有事件
            $('#calendar').fullCalendar('addEventSource', events) // 添加一个日程事件源
        },
        getviews() {
            // 取得视图对象信息
            return $('#calendar').fullCalendar('getView')
        },
        async queryData(views) {
            // 查询个人某段范围内的日程
            const view = this.getviews()
            this.start = view.start
            this.end = view.end
            console.log(view, 'view')
            const params = { startdate: this.start.format('YYYY-MM-DD') + ' 00:00:00', enddate: this.end.format('YYYY-MM-DD') + ' 00:00:00' }
            const events = []
            await this.$http({
                method: 'POST',
                contentType: 'application/x-www-form-urlencoded',
                params: params,
                url: this.moduleInfo.queryDataUrl
            }).then((response) => {
                if (response.code === 'success') {
                    const result = response.body.calendarList
                    result.forEach((item) => {
                        item.listDetail.forEach((calendar) => {
                            const vo = calendar
                            events.push({
                                id: vo.id,
                                title: vo.title,
                                startDate: vo.startDate,
                                start: vo.startDate.split(' ')[0] + ' ' + vo.startTime,
                                end: vo.endDate.split(' ')[0] + ' ' + vo.endTime,
                                block: true,
                                type: 'calender',
                                dupConfig: vo.dupConfig
                            })
                        })
                    })

                    this.options.events = events
                    this.viewData = events
                    // 重新渲染事件
                    this.renderEvent(events)
                } else {
                    // this.$alert(response.message, '错误', { type: 'error' })
                    this.$alert(response.message, this.$tx('ecoa.messages.errorTitle', '错误'), { type: 'error' })
                }
            })
        },
        // 新增
        addNew(edata) {
            this.$emit('addNewForm', edata)
        },
        // 查看
        view(item, startDate) {
            item.startDate = startDate
            this.$emit('viewObject', item)
        },
        viewObj(item) {
            if (item.id) {
                this.view(item, item.startDate)
            } else {
                this.addNew(item.date)
            }
        },
        // 删除
        deleteIds(item, startDate) {
            item.startDate = startDate
            this.$emit('deleteIds', item)
        },
        exportCalender() {
            if (this.viewData.length === 0) {
                // this.$alert('当前没有日程可以导出！', '', { type: 'warning' })
                this.$alert(this.$tx('ecoa.messages.exportCalenderAlter', '当前没有日程可以导出！'), '', { type: 'warning' })
                return
            }
            const header = [
                [
                    { title: '序号', width: 45, align: 'center', colspan: 1, rowspan: 1 },
                    { title: '主题', width: 300, align: 'left', colspan: 1, rowspan: 1 },
                    { title: '开始时间', width: 200, align: 'center', colspan: 1, rowspan: 1 },
                    { title: '结束时间', width: 200, align: 'center', colspan: 1, rowspan: 1 }
                ]
            ]
            // const weekobj = { 0: '周日', 1: '周一', 2: '周二', 3: '周三', 4: '周四', 5: '周五', 6: '周六' }
            const weekobj = { 0: this.$tx('common.Sunday', '周日'), 1: this.$tx('common.Monday', '周一'), 2: this.$tx('common.Tuesday', '周二'), 3: this.$tx('common.Wednesday', '周三'), 4: this.$tx('common.Thursday', '周四'), 5: this.$tx('common.Friday', '周五'), 6: this.$tx('common.Saturday', '周六') }

            const rows = []
            this.viewData.forEach((item, i) => {
                const weekstart = weekobj[new Date(item.start).getDay()]
                const weekend = weekobj[new Date(item.end).getDay()]

                const row = [
                    { value: i + 1, align: 'center', colspan: 1, rowspan: 1 },
                    { value: item.title, align: 'left', colspan: 1, rowspan: 1 },
                    { value: item.start.substr(0, 16) + ' ' + weekstart, align: 'center', colspan: 1, rowspan: 1 },
                    { value: item.end ? item.end.substr(0, 16) + ' ' + weekend : '', align: 'center', colspan: 1, rowspan: 1 }
                ]
                rows.push(row)
            })
            this.$http({
                method: 'POST',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' },
                data: qs.stringify({ rows: JSON.stringify(rows), titles: JSON.stringify(header), fileName: this.getviews().title.replace(/\s*/g, '') + '个人日程' }),
                url: 'common/exportXlsFile?httpPort=' + location.port
            }).then((res) => {
                if (res.code === 'success') {
                    window.open(encodeURI('/apigw/' + res.body.xlsurl), '_blank')
                } else {
                    // this.$alert(res.message, '操作提示', { type: 'error' })
                    this.$alert(res.message, this.$tx('common.operationTip', '操作提示'), { type: 'error' })
                }
            })
        }
    }
}
</script>

<style lang="scss">
@import '~@/wapp/common/styles/element-variables.scss';
#event-detail {
    opacity: 0;
    transition: opacity 0.4s;
    position: absolute;
    cursor: auto;
    top: 25px;
    right: -2px;
    background: #fff;
    padding: 10px 16px;
    border: 1px solid #ebeef5;
    border-radius: 4px;
    font-size: 12px;
    line-height: 2;
    min-width: 158px;
    word-wrap: break-word;
    z-index: 9999;
    color: #000;
    .arrow {
        border: 7px solid transparent;
        position: absolute;
        display: block;
        width: 0;
        height: 0;
        border-bottom-color: #ebeef5;
        right: 20px;
        top: -14px;
    }
    .arrow:after {
        border: 6px solid transparent;
        position: absolute;
        display: block;
        width: 0;
        height: 0;
        border-bottom-color: #fff;
        left: -5px;
        top: -6px;
        content: '';
    }
    .detail-list {
        margin-bottom: 10px;
    }
    .tip-title {
        font-size: 14px;
        font-weight: bold;
        width: 200px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
}
.fc-state-default.fc-corner-left {
    border-top-left-radius: 3px;
    border-bottom-left-radius: 3px;
}
.fc-state-default.fc-corner-right {
    border-top-right-radius: 3px;
    border-bottom-right-radius: 3px;
}
.calendar-container .person-calendar table tr td {
    padding: 0;
}
.fc-scroller.fc-time-grid-container {
    height: auto !important;
}
.fc {
    .fc-axis {
        padding: 0 5px !important;
        background: #f8f8f8;
    }
    .fc-content-skeleton .fc-axis {
        background: transparent;
    }
    .fc-button-group > * {
        background: transparent;
        padding: 9px 15px;
        font-size: 12px;
        line-height: 12px;
        color: #606266;
        height: 33px;
        border-color: rgb(220, 223, 230);
        box-shadow: none;
        outline: none;
    }
    .fc-button-group > *:hover,
    .fc-button-group .fc-state-active {
        /* background: $--color-primary; */
        box-shadow: none;
        color: $--color-primary;
        border-color: $--color-primary;
    }
    .fc-button-group .fc-state-disabled:hover {
        color: #606266;
        border-color: rgb(220, 223, 230);
    }
    .fc-list-table {
        tr td {
            padding: 8px 14px !important;
            border-left: 0;
            border-right: 0;
        }
        .fc-list-heading td {
            background: #f8f8f8;
            color: $--color-primary;
            font-size: 14px;
            font-weight: normal;
        }
    }
}
.fc-unthemed td {
    border-color: #e0e0e0 !important;
}
.person-calendar.fc-unthemed td.fc-today {
    color: var(--bgColor) !important;
    background: #f2f8fe;
}
.fc-unthemed td {
    border-color: #e0e0e0 !important;
}
.person-calendar {
    width: 100%;
    color: #606266;

    .fc-toolbar h2 {
        font-size: 22px;
        color: $--color-primary;
        font-weight: normal;
    }
    table tr th.fc-day-header {
        color: #666;
        height: 34px;
        line-height: 34px;
        border-right-color: #d8d8d8;
        background-color: #eef0f3;
    }
    .fc-event-container {
        padding: 0;
    }
    .fc-event-dot {
        background-color: $--color-primary !important;
    }
    .fc-event {
        font-size: 14px;
        line-height: 1.6;
        min-height: 40px;
        border-radius: 0;
        padding: 4px 10px;
        overflow: visible;
        .event_del {
            position: absolute;
            right: 2px;
            top: 0;
        }
    }
    .fc-h-event,
    .fc-event.fc-short {
        min-height: 20px;
    }
    .fc-day-grid-event .fc-time {
        font-weight: normal;
        margin-right: 8px;
    }
    /* .nonwork{
        position: relative;
    }
    .fc-other-month.nonwork{
        opacity: 0.6;
    }
    .nonwork a{
        color: #f73939;
    }
    td.nonwork:before{
        content: "休";
        position: absolute;
        left: 8px;
        top: 3px;
        font-size: 12px;
        color: #ff0000;
    } */
}
.fc-day-grid .fc-row:hover {
    z-index: 99;
}
.fc-row.fc-rigid {
    overflow: visible;
}
</style>

